import { render, staticRenderFns } from "./ModalsManager.vue?vue&type=template&id=1b8359c4&"
import script from "./ModalsManager.vue?vue&type=script&lang=js&"
export * from "./ModalsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports